import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../components/grid-container/GridContainer"
import London from "../../../../styles/img/favourites/london.jpg"
import Nike from "../../../../styles/img/favourites/nike.jpg"
import Tokyo from "../../../../styles/img/favourites/tokyo.jpg"
import UiContentCard from "../../components/cards/UiContentCard"


export default function TrendingAcrossSherbet(props) {
    const readMore = () => {
    }
    return (
        <>
            <UiCol lg="3" sm="6">
                <UiContentCard
                    cardImg={London}
                    rating="4.41"
                    reviews="47"
                    heading="London"
                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                    readMore={readMore}
                    footer="true"
                     />
            </UiCol>
            <UiCol lg="3" sm="6">
                <UiContentCard
                    cardImg={Nike}
                    rating="4.41"
                    reviews="47"
                    heading="Nike"
                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                    readMore={readMore}
                    footer="true"
                     />
            </UiCol>
            <UiCol lg="3" sm="6">
                <UiContentCard
                    cardImg={Tokyo}
                    rating="4.41"
                    reviews="47"
                    heading="Tokyo"
                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                    readMore={readMore}
                    footer="true"
                     />
            </UiCol>
            <UiCol lg="3" sm="6">
                <UiContentCard
                    cardImg={Nike}
                    rating="4.41"
                    reviews="47"
                    heading="Nike"
                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                    readMore={readMore}
                    footer="true"
                     />
            </UiCol>

        </>
    )
}
